// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__3qKTI","cell":"ColumnAccessor_cell__2pcdw","firstCellAccent":"ColumnAccessor_firstCellAccent__1c0wP"};